module.exports = __webpack_public_path__ + "static/media/Raffrollo_35618_120x160.1f0565cb.png";